




























import Vue from 'vue'
import { defaultVideoPlaceHolder, playBtnImage } from '../../helper/constants'
export default Vue.extend({
  props: {
    video: Object,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoPlaceholderImg: defaultVideoPlaceHolder,
      playBtnImage,
      loadVideo: false
    }
  }
})
